/**
 * Converts page-based pagination into offset-based pagination.
 *
 * @param page - The current page number (1-based index)
 * @param itemsPerPage - Number of items per page
 * @returns An object with offset and limit
 */
export function getPaginationParams(page: number, itemsPerPage: number) {
  const safePage = Math.max(1, page); // Ensure page is at least 1
  const offset = (safePage - 1) * itemsPerPage;
  const limit = itemsPerPage;

  return { offset, limit };
}
